import { getAppFrontendUrl, getCookieDomain, getLoginUrl, isRunningLocally } from 'src/app/shared/utility/is-local.util';

export const environment = {
  appDomain: 'qa.profet.ai',
  appFrontendUrl: getAppFrontendUrl('https://valuation.qa.profet.ai'),
  backendBaseUrl: 'https://profet-valuation-backend.qa.profet.ai',
  portal: {
    backendBaseUrl: 'https://profet-portalbackend.qa.profet.ai',
    frontendBaseUrl: 'https://portal.qa.profet.ai',
  },
  workflow: {
    backendBaseUrl: 'https://qa-orders-backend.profet.ai',
  },
  logInUrl: getLoginUrl('https://portal.qa.profet.ai/login'),
  cognitoUserPoolId: 'us-west-2_2xQCylnqb',
  cognitoAppClientId: '5vj2i4os2d6ghbvqlmp21s98v6',
  cognitoAuthDomain: 'profet-app-dev.auth.us-west-2.amazoncognito.com',
  cookieStorage: {
    // - Cookie domain (only required if cookieStorage is provided)
    domain: getCookieDomain('.qa.profet.ai'),
    // (optional) - Cookie path
    path: '/',
    // (optional) - Cookie expiration in days
    expires: 1,
    // (optional) - See: https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Set-Cookie/SameSite
    sameSite: 'strict',

    // (optional) - Cookie secure flag
    // Either true or false, indicating if the cookie transmission requires a secure protocol (https).
    secure: true,
  },
  googleMapsApiKey: 'AIzaSyDsp3EqkOIfIBJL63qcVcZLSoYsPqfmCNA',

  /**
   * Runtime detection of local development environment.
   * Detects based on hostname and port, regardless of environment config.
   * This value is determined once when the application loads.
   */
  isRunningLocally: isRunningLocally(),
};
